import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import coupleImage from './img/couple-image.jpg'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName, coupleSingleName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'JÁ SE CASARAM'
      : 'VÃO SE CASAR'
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro306">
      <div className="intro306mobile screen">
        <div className="main-background-TO1dwL"></div>
        <div className="container-center-horizontal">
          <div className="button-TO1dwL">
            <div
              className="site-de-casamento-e-zZ11DO"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-zZ11DO" onClick={onSkipIntro}>
              <div className="button-IxxD17"></div>
              <div className="pular-introduo-IxxD17">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-TO1dwL">
            <div className="color-frame-QHN4xe"></div>
            <div className="frame-QHN4xe"></div>
            <div className="couple-image-QHN4xe">
              <img className="image-5sbgwI" src={background || coupleImage} />
            </div>
            <div className="mariana-eduardo-QHN4xe bp2-animate-enter">
              {coupleSimplifiedName.bride}{' '}
              {coupleSimplifiedName.groom && (
                <>
                  &amp; <span>{coupleSimplifiedName.groom}</span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="intro306desktop screen">
        <div className="main-background-zrPtOb bp1-animate-enter"></div>
        <div className="container-center-horizontal">
          <div className="button-zrPtOb">
            <div
              className="site-de-casamento-e-j5oXwa"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-j5oXwa" onClick={onSkipIntro}>
              <div className="button-mDkqWc"></div>
              <div className="pular-introduo-mDkqWc">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-zrPtOb">
            <div className="color-frame-BLk5wx"></div>
            <div className="frame-BLk5wx"></div>
            <div className="couple-image-BLk5wx">
              <img className="image-5ADFJy" src={background || coupleImage} />
            </div>
            <div className="date-BLk5wx bp1-animate-enter1">{text}</div>
            <div className="mariana-eduardo-BLk5wx bp1-animate-enter2">
              {coupleSingleName.bride}{' '}
              {coupleSingleName.groom && (
                <>
                  <span className="coupleSingleName">
                    &amp; {coupleSingleName.groom}
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
